import type { VerificationType } from '@entities/Authentication/types.ts';
import { openNotifyModal } from '@src/library/redux/modal/index.ts';

export const getTitle = (verification_type?: VerificationType) => {
  switch (verification_type) {
    case 'reset_email': {
      return 'Изменение адреса электронной почты';
    }
    case 'reset_phone': {
      return 'Подтвердите номер телефона';
    }
    case 'registration': {
      return 'Подтвердите почту';
    }
    default: {
      return undefined;
    }
  }
};
export const shopCantEditEmailAndPhoneNotify = () =>
  openNotifyModal({
    text: 'Нельзя одновременно изменить номер телефона и адрес электронной почты',
    confirmText: 'Понятно',
    title: 'Уведомление',
  });
